import css from 'styled-jsx/css';

const styles = css.global`html{
   scroll-behavior: smooth;
}


.btnScrollTop {
    background: #CC0000;
    box-sizing: border-box;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 2px 16px #222222;
    position: fixed;
    bottom: 17px;
    right: 37px;
    border: none;
    cursor: pointer;
    outline: none;
}

@media (min-width: 992px) {
    .btnScrollTop {
        width: 56px;
        height: 56px;
        bottom: 48px;
        right: 80px;
        z-index: 1;
    }
}`;

export default styles;